import { PkCarousel } from '@uefadigital/panenka-react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useOptions } from '../../hooks';
import { loadPreviousPoll } from '../../models/polls';
import { useAppDispatch, useAppSelector } from '../../store';
import type { PollType } from '../../types';
import ErrorBoundary from '../../utils/ErrorBoundary';

import Poll from './Poll';

import * as style from './style.module.scss';

const PreviousPolls = ({ excludedPoll }: { excludedPoll?: string }) => {
  const previousPolls = useAppSelector((state) => state.polls.previousPolls);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { cup, seasonYear, pollType, pollSubtype, appType, appName } = useOptions();

  useEffect(() => {
    dispatch(
      loadPreviousPoll({
        cup,
        seasonYear,
        pollType,
        pollSubtype,
        appType,
        excludedId: excludedPoll,
      }),
    );
  }, [appType, cup, dispatch, excludedPoll, pollSubtype, pollType, seasonYear]);

  const showPreviousPoll = !!previousPolls?.data?.length;

  const itemsCount = previousPolls?.data?.length ?? 0;
  const item0 = itemsCount === 1 ? 1 : 1.2;
  const item440 = itemsCount === 1 ? 1 : 1.4;
  const item768 = itemsCount <= 2 ? 2 : 2.2;
  const item960 = itemsCount <= 3 ? 3 : 3.3;
  const item1200 = itemsCount <= 3 ? 3 : 3.4;
  const item1440 = itemsCount <= 4 ? 4 : 4.2;

  const breakpoints = {
    '0': { slidesPerView: item0, slidesPerGroup: 1, spaceBetween: 16 },
    '440': { slidesPerView: item440, slidesPerGroup: 1, spaceBetween: 16 },
    '768': { slidesPerView: item768, slidesPerGroup: 2, spaceBetween: 16 },
    '960': { slidesPerView: item960, slidesPerGroup: 3, spaceBetween: 32 },
    '1200': { slidesPerView: item1200, slidesPerGroup: 3, spaceBetween: 32 },
    '1440': { slidesPerView: item1440, slidesPerGroup: 4, spaceBetween: 32 },
  };

  return (
    <ErrorBoundary>
      {showPreviousPoll && (
        <div className={style.gotxPreviousPolls}>
          <PkCarousel breakpoints={JSON.stringify(breakpoints)}>
            <div slot='headline'>
              <span>{t(`previous_winners`)}</span>
              <span className={style.pollSubtitle}>
                {t(`title_${cup}`)} {t(`${appName}`)}
              </span>
            </div>
            {previousPolls?.data?.map((p: PollType) => <Poll key={p.id} poll={p} />)}
          </PkCarousel>
        </div>
      )}
    </ErrorBoundary>
  );
};

export default PreviousPolls;
